import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import { Checkbox } from 'ui-components/components/checkbox/';
import { useShipFrom } from '../../../hooks/ship-froms/use-ship-from';
import { useShipFroms } from '../../../hooks/ship-froms/use-ship-froms';
import { useShipFromContext } from '../../contexts/ship-from-context';

import messages from '../messages';
import style from '../style.module.less';

const DefaultLocationCheckbox = () => {
  const { shipFrom, updateShipFrom } = useShipFromContext();
  const entityShipFrom = useShipFrom(shipFrom.shipFromId);
  const shipFroms = useShipFroms();
  const sellerHasShipFroms = !!shipFroms.length;
  const intl = useIntl();

  const isEntityAlreadyDefault = entityShipFrom?.isDefault ?? false;
  const onChange = useCallback(
    (checked) => {
      if (isEntityAlreadyDefault) {
        return;
      }

      updateShipFrom({
        isDefault: checked,
      });
    },
    [isEntityAlreadyDefault, updateShipFrom],
  );

  const labelMessageDescriptor = isEntityAlreadyDefault ? messages.existingDefaultLocation : messages.useAsDefaultLocation;

  return (
    <div>
      {sellerHasShipFroms && (
        <Checkbox
          checked={shipFrom.isDefault}
          className={classnames(style.checkbox, style['default-location'])}
          disabled={isEntityAlreadyDefault}
          label={intl.formatMessage(labelMessageDescriptor)}
          onChange={onChange}
        />
      )}
    </div>
  );
};

export default DefaultLocationCheckbox;
